import cx from 'classnames';
import { jsx } from '@emotion/react';
import styles from './Heading3.css';
const COLORS = {
    grey: 'uil-color-grey-800',
    'light-grey': 'uil-color-grey-300',
    white: 'uil-color-white',
};
const FONT_WEIGHTS = {
    normal: 'uil-fw-normal',
    semibold: 'uil-fw-semibold',
};
/** This component is used in most cases inside a `SectionHeader` or as the name would imply, as a `Section` title.
 *
 * There are few other occasions where it can also be used as stand-alone element.
 */
const Heading3 = ({ children, color = 'grey', fontWeight = 'normal', icon: CustomIconTag, iconProps = {}, tag: CustomTag = 'h3', ...other }) => {
    const { className: iconClassName, css: iconCss, ...otherIconProps } = iconProps;
    const { className: otherClassName, ...otherProps } = other;
    return (jsx(CustomTag, Object.assign({}, otherProps, { className: cx('uil-fsz-18 uil-fw-normal uil-ff-poppins uil-lh-big lg:uil-fsz-24', COLORS[color], FONT_WEIGHTS[fontWeight], CustomIconTag && 'uil-d-flex uil-ai-top', otherClassName) }),
        CustomIconTag && (jsx(CustomIconTag, Object.assign({}, otherIconProps, { css: [styles.icon, iconCss], className: cx('uil-mr-8 uil-w-18 uil-h-18 uil-pos-relative uil-fxs-0 lg:uil-w-24 lg:uil-h-24', iconClassName) }))),
        children));
};
export default Heading3;
